"use client";

import { motion } from "framer-motion";
import FeatureCards from "./FeatureCards";
import { Products } from "@/types/productsTypes";

export default function Features({ section }: { section: Products['atlaside']['features'] }) {
    return (
        <section className="section-bg py-32">
            <div className="max-w-7xl mx-auto relative z-10">
                <motion.div 
                    className="text-center mb-12"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                >
                    <p className="w-fit mx-auto badge-size section-badge mb-1">{section.badge}</p>
                    <h2 className="title-size font-bold mb-4 title-bg-secondary">{section.title}</h2>
                    <p className="text-size text-muted-foreground max-w-4xl mx-auto">{section.description}</p>
                </motion.div>

                <FeatureCards section={section.cards} />
            </div>
        </section>
    )
}